// extracted by mini-css-extract-plugin
module.exports = {"vgIndexDisplay":"_2yWSU","itemIndexInput":"_1pn0i"};